module.exports = __webpack_public_path__ + "img/bitvavo-dark.d11b11d7.png";